<template>
  <div>
    <section
      v-if="dateTime.end_time && dateTime.start_time"
      :class="textSizeClass"
      class="inline-block"
    >
      <span :class="{ 'font-medium': textBold }" class="text-black">
        {{ dayjs(dateTime.start_time).format('YYYY/MM/DD') }}
      </span>
      <span :class="timeTextClass">
        {{ dayjs(dateTime.start_time).format('HH:mm') }}
      </span>
      <span>-</span>
      <span v-if="!inSameDay(dateTime)" :class="{ 'font-medium': textBold }" class="text-black">
        {{ dayjs(dateTime.end_time).format('YYYY/MM/DD') }}
      </span>
      <span :class="timeTextClass">
        {{ dayjs(dateTime.end_time).format('HH:mm') }}
      </span>
    </section>
    <section v-else-if="dayjs(dateTime).isValid()" :class="textSizeClass" class="inline-block">
      <span :class="{ 'font-medium': textBold }" class="text-black">
        {{ dayjs(dateTime).format('YYYY/MM/DD') }}
      </span>
      <span :class="timeTextClass">
        {{ dayjs(dateTime).format('HH:mm') }}
      </span>
    </section>
  </div>
</template>

<script>
import WDateTimeDisplay from './WDateTimeDisplay';

export default WDateTimeDisplay;
</script>
